<template>
  <component :is="element" :class="CellListWrapperClass">
    <component
      v-for="(cellInfo, index) in cellList"
      :key="`cell${index}`"
      :is="component"
      :cell-info="cellInfo"
      :thumbnail-info="thumbnailInfo"
      :cell-index="index"
      v-on="$listeners"
    />
  </component>
</template>
<script>
import { get } from 'lodash'
import PortraitCell from '@/components/section/template/cell/PortraitCell'
import LandscapeCell from '@/components/section/template/cell/LandscapeCell'
import CircleCell from '@/components/section/template/cell/CircleCell'
export default {
  name: 'CellList',
  data () {
    return {
      component: null
    }
  },
  components: {
    PortraitCell,
    LandscapeCell,
    CircleCell
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  computed: {
    CellListWrapperClass () {
      let cellType = 'landscape'
      const thumbnailType = get(this.thumbnailInfo, 'type', '')
      if (thumbnailType === 'poster') {
        cellType = 'portrait'
      } else if (thumbnailType === 'circle') {
        cellType = 'circle'
      }
      return `swiper-wrapper ${cellType}`
    },
    element () {
      const cellType = get(this.thumbnailInfo, 'cellType', '')
      return cellType === 'band_98' || cellType === 'band_94' ? 'ol' : 'ul'
    }
  },
  created () {
    this.component = get(this.thumbnailInfo, 'componentName', '')
  }
}
</script>
<style scoped>
/*.cell-list {*/
/*background-color: #fff;*/
/*}*/
.cell-circle .cell-img.clip,
.cell-circle .cell-img.live {
  width: 84px;
  height: 84px;
}

.cell-circle .cell-img.clip img,
.cell-circle .cell-img.live img{
  width: 100%;
  height: 100%;
  margin: 0 0 0 0;
}

img[lazy=loading] {
  opacity: 0.5;
}

img[lazy=error] {
  opacity: 1;
}

img[lazy=loaded] {
  -webkit-transition: opacity 350ms ease-in-out;
  -moz-transition: opacity 350ms ease-in-out;
  -o-transition: opacity 350ms ease-in-out;
  transition: opacity 350ms ease-in-out;
}
.tag-age {
  position: absolute;
  height: 20px;
}
.progress-bar{
  display: block;
  height: 3px;
  background-color: #1351f9;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5654e1', endColorstr='#2ac5fe', gradientType=1);
}
.circle{
  height: 84px;
}
.circle-progress {
  position: absolute;
  z-index: 100;
  width: 84px;
  height: 84px;
  border-radius: 42px;
  overflow: hidden;
}
.circle-img {
  width: 84px;
  height: 84px;
  border-radius: 42px;
  overflow: hidden;
}
/* 첫번째 vod 재생 overlay */
.vod-playnow:after{
  position: absolute;
  display: block;
  content: '';
  top: 50%;
  margin-top: -18px;
  left: 50%;
  margin-left: -18px;
  width: 36px;
  height: 36px;
  background: url(/img/common/ic-now-play.png);
  background-size: 36px 36px;
  z-index: 200;
}
.cell-img.adult {
  position: relative;
}
.cell-img.adult .tag-age{
  opacity: 0.2;
}

/*
.cell-img.adult img{
  z-index: 500 !important;
  opacity: 0.1;
  background-color: #000000;
}*/

.cell-img .adult-21{
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 46px;
  height: 46px;
}
</style>
